// Theme CSS (global styles, components, navigation, header, footer).
import '../scss/main.entry.scss';

// Bootstrap JS — import only what the theme uses.
import { Carousel, Collapse, Dropdown, Offcanvas } from 'bootstrap';

// Custom theme modules.
import './navigation.js';
import './swiper-fade.js';

document.addEventListener('DOMContentLoaded', () => {
    initCarousels();
});

// Initialize all Bootstrap carousels.
function initCarousels() {
    document.querySelectorAll('[data-bs-ride="carousel"]').forEach((el) => {
        new Carousel(el, {
            interval: 5000,
            ride:     'carousel',
        });
    });
}

// Open all external links in a new tab
document.querySelectorAll('a[href^="http"]').forEach(link => {
    if (!link.href.includes(location.hostname)) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
    }
});